import React, { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { CheckCircleFill } from 'react-bootstrap-icons';
import { Button } from "@material-ui/core";

export const ConnectWallet = ({ onLogin }) => {
  const {isLoggedIn, isConnected, login, connect, address } = useContext(AuthContext);

  const connectAndLogin = async () => {
    const address = await connect();
    await login(address);

    if (onLogin) {
      onLogin();
    }
  }

  return (
    <>
      {(!isConnected || !isLoggedIn) && (
        <Button variant="contained" onClick={connectAndLogin}>Login with Metamask</Button>
      )}
      <div>
      <small><small>
        {isLoggedIn && (<><span style={{fontStyle: 'italic'}}>{address}</span>{' | '}</>)}
        {isConnected && (<><CheckCircleFill style={{ position: 'relative', bottom: -2 }} />&nbsp;Connected</>)}&nbsp;
        {isLoggedIn && (<><CheckCircleFill style={{ position: 'relative', bottom: -2 }} />&nbsp;Logged In</>)}{' '}
      </small></small>
      </div>
    </>
  );
}
